import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StrategicVisionHero from "./sections/StrategicVisionHero";
import OurCorePhilosophy from "./sections/OurCorePhilosophy";
import OperationalFoundation from "./sections/OperationalFoundation";
import StrategicSpecialists from "./sections/StrategicSpecialists";
import PortfolioOperations from "./sections/PortfolioOperations";
import AccessTheNetwork from "./sections/AccessTheNetwork";
import GlobalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <StrategicVisionHero />
      <OurCorePhilosophy />
      <OperationalFoundation />
      <StrategicSpecialists />
      <PortfolioOperations />
      <AccessTheNetwork />
      <GlobalFooter />
    </div>;
}